import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AppProvider } from './lib/store';
// Layout
import { AppLayout } from './components/layout/AppLayout';
// Pages
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { WorkOrderListPage } from './pages/WorkOrderListPage';
import { WorkOrderFormPage } from './pages/WorkOrderFormPage';
import { WorkOrderDetailPage } from './pages/WorkOrderDetailPage';
import { CustomerListPage } from './pages/CustomerListPage';
import { CustomerFormPage } from './pages/CustomerFormPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';
import { UserListPage } from './pages/UserListPage';
import { SettingsPage } from './pages/SettingsPage';
export function App() {
  return <AppProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/login" element={<LoginPage data-id="element-4" />} data-id="element-3" />

          <Route path="/" element={<AppLayout data-id="element-6" />} data-id="element-5">
            <Route index element={<DashboardPage data-id="element-8" />} data-id="element-7" />

            {/* Work Orders */}
            <Route path="nalogi" element={<WorkOrderListPage data-id="element-10" />} data-id="element-9" />
            <Route path="nalogi/nov" element={<WorkOrderFormPage data-id="element-12" />} data-id="element-11" />
            <Route path="nalogi/:id" element={<WorkOrderDetailPage data-id="element-14" />} data-id="element-13" />
            <Route path="nalogi/:id/uredi" element={<WorkOrderFormPage data-id="element-16" />} data-id="element-15" />

            {/* Customers */}
            <Route path="stranke" element={<CustomerListPage data-id="element-18" />} data-id="element-17" />
            <Route path="stranke/nova" element={<CustomerFormPage data-id="element-20" />} data-id="element-19" />
            <Route path="stranke/:id" element={<CustomerDetailPage data-id="element-22" />} data-id="element-21" />
            <Route path="stranke/:id/uredi" element={<CustomerFormPage data-id="element-24" />} data-id="element-23" />

            {/* Admin */}
            <Route path="uporabniki" element={<UserListPage data-id="element-26" />} data-id="element-25" />
            <Route path="nastavitve" element={<SettingsPage data-id="element-28" />} data-id="element-27" />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-30" />} data-id="element-29" />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors data-id="element-31" />
      </BrowserRouter>
    </AppProvider>;
}